import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Table, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { deleterDispatchHelper } from 'actions/DeleterActions';
import {parseQs, toQueryString} from 'helpers/http';

import ClientListInfo from 'components/layout/ClientListInfo';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import ListFilterReset from 'components/layout/list/ListFilterReset';

import List from 'components/List';

import UserNew from 'components/modals/UserNew';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE } from 'js/constants';
import axios from 'axios';
import Axios from "axios";
import fileDownload from "js-file-download";
import {confirmAlert} from "react-confirm-alert";

class Users extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      undeletingUsernames: [],
      isDownloading: false,
    };
  }

  // change the url to display client information
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.users },
        ]}
        className="p-t-0"
      />
    );
  };

  handleRemoveClick = (e, userId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteUser } = this.props;
    deleteUser(userId);
  };

  handleUndeleteClick = (e, userId) => {
    const { undeletedUser } = this.props;
    const { undeletingUsernames } = this.state;
    e.preventDefault();
    e.stopPropagation();

    axios({
      method: 'put',
      url: `/api/clients/${userId}/undelete.json`,
      data: { isDeleted: false },
    })
      .then(({ is_deleted: isDeleted }) => {
        // destructuring assignment to a list.data.list with a default to an empty array, no errors thrown
        const { list: { data: { list = [] } = {} } = {} } = this.props;
        const user = list.find(({ username }) => username === userId);
        if (user && user.is_deleted !== isDeleted) {
          undeletedUser(userId); // dispatches action to update the state list
          // remove the successfully undeleted username from the list
          this.setState({ undeletingUsernames: undeletingUsernames.filter(({ username }) => username !== userId) });
        }
      })
      .catch(console.error);

    // add the username being undeleted to the list
    this.setState({ undeletingUsernames: [...new Set([...undeletingUsernames, userId])] });
  };

  getUserList = () => {
    const {
      list,
      intl: { messages },
      location,
    } = this.props;

    const params = new URLSearchParams();
    params.set('csv', 'users');

    const {
      data: { count },
      activePage,
      resPerPage,
      searchTerm,
      sort,
      dir,
    } = list;

    const offset = count > 0 ? (activePage - 1) * resPerPage : 0;

    params.set('offset', offset);
    params.set('limit', resPerPage);
    params.set('search', searchTerm);
    params.set('sort', sort);
    params.set('dir', dir);
    params.set('page', activePage);
    params.set('locale', 'de');

    const urlData = this.getUrlData(parseQs(location.search));
    const additionalQuery = toQueryString(urlData);
    const urlString = `/api/clients/for/download.json?${params.toString()}&${additionalQuery}`;
    this.setState({ isDownloading: true });

    Axios({
      url: urlString,
      method: 'GET',
      responseType: 'blob',
    })
      .then(({ data, headers }) => {
        const filename = headers?.['content-disposition']?.split?.('filename=')?.[1] ?? 'users.csv';
        fileDownload(data, filename);

        this.setState({ isDownloading: false }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.salesDoc.download_csv_ready}</h1>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="primary"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('post Request canceled');
        } else {
          console.error(error);
        }
      });
  };

  /**
   * Construct an object with 'filters': { target, paymentMethod }
   */
  getUrlData = (query) => {
    const urlData = { filters: { type: '!company', ancestors: query.ancestors } };
    return urlData;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
      location,
    } = this.props;
    const { showNew, undeletingUsernames, isDownloading } = this.state;

    const query = parseQs(location.search);

    const columns = [messages.user, messages.actions];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const client = list.data.list[i];
      const { username, is_active: isActive, is_deleted: isDeleted } = client;

      const detailsUrl = appIntl.urlPrefix + 'account/settings/users/' + username;
      const impersonateUrl = appIntl.urlPrefix + 'account?_switch_user=' + username;
      const isAllowedToImpersonate = may(ROLE_ROOT_EMPLOYEE, user.roles) && !isDeleted && username !== 'CreacheckAdmin';

      tBody.push(
        <tr
          key={i}
          className={`clickable ${isActive ? '' : 'hint-text'}`}
          onClick={() => !isDeleted && this.handleRowClick(detailsUrl)}
        >
          <td class="v-align-middle">
            <ClientListInfo client={client} />
          </td>
          <td class="v-align-middle text-right">
            {may('ROLE_ADMIN', user.roles) &&
              (isDeleted ? (
                <>
                  <SimplePrompt
                    bsStyle="info"
                    buttonLabel={messages.undelete}
                    iconClass="fa fa-trash-undo"
                    showMessage={messages.undelete_user_confirm}
                    onSuccess={e => this.handleUndeleteClick(e, username)}
                    disabled={undeletingUsernames.includes(username)}
                  />
                </>
              ) : (
                <>
                  <Link to={detailsUrl} class="btn-rounded m-r-10 btn btn-sm btn-default">
                    <i class="fa fa-pencil-alt" /> {messages.edit}
                  </Link>
                  <SimplePrompt onSuccess={e => this.handleRemoveClick(e, username)} />
                </>
              ))}
            {isAllowedToImpersonate && (
              <Button
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.location.href = impersonateUrl;
                }}
                className="btn-rounded m-l-10"
              >
                <i class="fas fa-theater-masks" /> {messages.impersonate}
              </Button>
            )}
          </td>
        </tr>
      );
    }

    const filters = [];
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      filters.push(<ListFilterCompany key="ancestors" paramName="ancestors" />);
      filters.push(<ListFilterReset key="reset-all" availableFilters={['ancestors']} />);
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map(column => {
              return (
                <th key={column} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.users)}>
        <List
          listName="users"
          url="/api/clients.json"
          urlData={{ filters: { type: '!company', ancestors: query.ancestors } }}
          list={list}
          title={messages.users}
          iconClass="fa fa-id-badge"
          showNew
          newText={messages.add_user}
          newAction={this.showNew}
          showSearch
          sortOptions={['relevance,desc', 'username,asc', 'lastName,asc']}
          breadcrumb={this.getBreadcrumb()}
          filters={filters}
        >

          {may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
            <Button bsStyle="default" onClick={() => this.getUserList()} disabled={false}>
              <p style={{ margin: '0' }}>
                {isDownloading && <i className="far fa-spin fa-spinner-third" />}
                <span> {messages.download_user_list}</span>
              </p>
            </Button>
          ) : (
            <></>
          )}

          {resultTable}

          <div id="user-new">
            <UserNew show={showNew} close={this.closeNew} />
          </div>
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.users,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteUser: userId => {
      deleterDispatchHelper('user', '/api/clients/' + userId + '.json', dispatch);
    },
    undeletedUser: username => dispatch({ type: 'UNDELETED_USER', payload: { username } }),
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Users)
  )
);
